import yup from '@/helpers/yup';

import { getRequired } from '@/helpers/form-fields-error-messages';

export default yup.object().shape({
  ip: yup.string().required(getRequired('IP')),
  description: yup.string().optional(),
});
